const History = () => {
   return (
      <div className="main-text">
         <h5>History</h5>
         <p>
            I'm baby wolf pickled schlitz try-hard normcore marfa man bun
            mumblecore vice pop-up XOXO lomo kombucha glossier bicycle rights.
            Umami kinfolk salvia jean shorts offal venmo. Knausgaard tilde
            try-hard, woke fixie banjo man bun. Small batch tumeric mustache tbh
            wayfarers 8-bit shaman chartreuse tacos. Viral direct trade hoodie
            ugh chambray, craft beer pork belly flannel tacos single-origin
            coffee art party migas plaid pop-up.
         </p>
      </div>
   );
};
export default History;
